import {UsersBackendUtils} from "@/modules/mprofiles/database/UsersBackendUtils";
import {TimeUtils} from "@/common/TimeUtils";

export class MultipleSnapshotsDownloader {
    constructor(uids) {
        this._uids = uids;
        this._checked = [];
        this._blobs = [];
        this._onComplete = null;
    }

    setOnComplete(value){
        this._onComplete = value;
    }

    init(){
         let item = this._uids.find(e => !this._checked.includes(e));
         if (item != null){
             this.next(item);
         }else{
             let JSZip = require("jszip");
             let zip = new JSZip();
             for (let i in this._blobs){
                 let item = this._blobs[i];
                 zip.file(item.uid + "_save.txt", item.blob);
             }
             let promise = zip.generateAsync({type : "blob"})
             promise.then((blob) => {
                 let FileSaver = require('file-saver');
                 FileSaver.saveAs(blob, "shapshots_"+TimeUtils.now()+".zip");
                 if (this._onComplete){
                     this._onComplete(1);
                 }
             }).catch((error) => {
                 console.log("error:", error)
                 if (this._onComplete){
                     this._onComplete(0);
                 }
             })
         }
    }
    next(uid){
        UsersBackendUtils.fetchUserSave(uid).then((data) => {
            console.log("succes: ", uid);
            if(Object.hasOwn(JSON.parse(data), 'profile')){
                this._blobs.push({"uid": uid, "blob": new Blob(data, {type: "text/plain;charset=utf-8"})});
            }
            this._checked.push(uid);
            this.init();
        }).catch((error) => {
            console.log("fail: ", uid, error);
            this._checked.push(uid);
            this.init();
        })
    }
}